import { enumAssistantAggregateType } from '@rematter/frontend-lib-api-client';
import { Col, Loading, Row, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import { LucideMessageCircle, LucideMessageSquare } from 'lucide-react';

import {
  $remoteAssistantOutboxEventCounts,
  useAssistantAggregateTypeFilter,
} from '@/audit-log/_state/assistantEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

const aggregateTypeConfig = [
  {
    type: enumAssistantAggregateType.Chat,
    labelKey: 'chat' as const,
    icon: LucideMessageSquare,
    countKey: 'chat' as const,
  },
  {
    type: enumAssistantAggregateType.ChatMessage,
    labelKey: 'chatMessage' as const,
    icon: LucideMessageCircle,
    countKey: 'chatMessage' as const,
  },
];

//
// ⚛️ ⚛️ ⚛️ ASSISTANT EVENTS SIDEBAR ⚛️ ⚛️ ⚛️
//
export const AssistantEventsSidebar = () => {
  const t = useTranslations();

  // Atoms
  const { data: counts, isLoading } = useAtomValue(
    $remoteAssistantOutboxEventCounts,
  );
  const [selectedType, setSelectedType] = useAssistantAggregateTypeFilter();

  const totalCount = counts ? counts.chat + counts.chatMessage : 0;

  return (
    <Col className="@AssistantEventsSidebar w-[200px] border-r border-neutral/10 p-3">
      <Loading isLoading={isLoading}>
        <Col gap2>
          <button
            onClick={() => setSelectedType(undefined)}
            className={cn(
              'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
              selectedType === undefined && 'bg-primary/10 text-primary',
              selectedType !== undefined && 'hover:bg-neutral/5',
            )}
          >
            <span>{t.assistantEventsView.sidebar.all}</span>
            <span className="text-xs text-neutral/50">{totalCount}</span>
          </button>

          {aggregateTypeConfig.map(
            ({ type, labelKey, icon: Icon, countKey }) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={cn(
                  'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
                  selectedType === type && 'bg-primary/10 text-primary',
                  selectedType !== type && 'hover:bg-neutral/5',
                )}
              >
                <Row gap2 yCenter>
                  <Icon size={16} className="text-neutral/60" />
                  <span>
                    {t.assistantEventsView.sidebar.aggregateTypes[labelKey]}
                  </span>
                </Row>
                <span className="text-xs text-neutral/50">
                  {counts?.[countKey] ?? 0}
                </span>
              </button>
            ),
          )}
        </Col>
      </Loading>
    </Col>
  );
};
